<template>
  <div id="sharecare-windows-page">
    <section class="featured-header">
      <div class="featured-header-video-bg lazyload" :data-bg="`${staticAssetPath}/img/sharecare-windows/mobile-header-bg.png`">
        <video class="video-source lazyload" playsinline loop autoplay muted type="video/mp4" source data-src="//d1ejplzm1ffl3m.cloudfront.net/promo/main_static/video/sharecare-windows-video.mp4"></video>
      </div>
      <div class="featured-header-content">
        <div class="logo">
            <picture>
              <source media="(max-width: 1024px)" :srcset="`${staticAssetPath}/img/sharecare-windows/sharecare-logo-mobile.jp2`" type="image/jp2">
              <source media="(min-width: 1025px)" :srcset="`${staticAssetPath}/img/sharecare-windows/sharecare-logo-desktop.jp2`" type="image/jp2">
              <source media="(max-width: 1024px)" :srcset="`${staticAssetPath}/img/sharecare-windows/sharecare-logo-mobile.webp`" type="image/webp">
              <source media="(min-width: 1025px)" :srcset="`${staticAssetPath}/img/sharecare-windows/sharecare-logo-desktop.webp`" type="image/webp">
              <source media="(max-width: 1024px)" :srcset="`${staticAssetPath}/img/sharecare-windows/sharecare-logo-mobile.png`">
              <source media="(min-width: 1025px)" :srcset="`${staticAssetPath}/img/sharecare-windows/sharecare-logo-desktop.png`">
              <img :src="`${staticAssetPath}/img/sharecare-windows/sharecare-logo-desktop.png`" alt="Sharecare windows">
            </picture>
        </div>
        <div class="featured-tagline"><h1>Your view to a happier, healthier life</h1></div>
      </div>
    </section>

    <section class="transformational-videos section-padding">
      <div class="row">
        <H2FeaturedHeader featuredHeader="Transformational videos for mind, body and spirit"/>
        <FeaturedSubHeader featuredContent="Sharecare Windows is an award-winning globally recognized producer of original HD and VR relaxation and wellness videos, empowering viewers to find stillness and peace in their everyday life. Sharecare Windows’ video library is specifically curated to include five specialty categories containing with hundreds of hours of relaxation, spiritual, meditation, sleep and background video programming.<br /><br />Clinical usage has shown Sharecare Windows’ videos to be effective in reducing intrusive noise levels, encouraging healthy sleep patterns and reducing stress." />
        
        <div class="video-callouts-container">
          <ul>
            <StandardListItemCalloutWithLinkText
            assetFolder="sharecare-windows"
            calloutImgName="comfort.png"
            calloutImgNameWebp="comfort.webp"
            calloutImgNameJP2="comfort.jp2"
            calloutText="Preview"
            alternativeText="Water with mountains"
            calloutTextLink="https://vimeo.com/showcase/6686972"
            />

            <StandardListItemCalloutWithLinkText
            assetFolder="sharecare-windows"
            calloutImgName="relax.png"
            calloutImgNameWebp="relax.webp"
            calloutImgNameJP2="relax.jp2"
            calloutText="Preview"
            alternativeText="Beach chairs looking out to water"
            calloutTextLink="https://vimeo.com/showcase/6686868"
            />

            <StandardListItemCalloutWithLinkText
            assetFolder="sharecare-windows"
            calloutImgName="sleep.png"
            calloutImgNameWebp="sleep.webp"
            calloutImgNameJP2="sleep.jp2"
            calloutText="Preview"
            alternativeText="Rocks on the water"
            calloutTextLink="https://vimeo.com/showcase/6687275"
            />

            <StandardListItemCalloutWithLinkText
            assetFolder="sharecare-windows"
            calloutImgName="listen.png"
            calloutImgNameWebp="listen.webp"
            calloutImgNameJP2="listen.jp2"
            calloutText="Preview"
            alternativeText="Huge waterfall"
            calloutTextLink="https://vimeo.com/showcase/6560717"
            />

            <StandardListItemCalloutWithLinkText
            assetFolder="sharecare-windows"
            calloutImgName="play.png"
            calloutImgNameWebp="play.webp"
            calloutImgNameJP2="play.jp2"
            calloutText="Preview"
            alternativeText="Animals in the forest"
            calloutTextLink="https://vimeo.com/showcase/6687297"
            />
          </ul>
        </div>
      </div>
    </section>

    <section class="sharecare-windows-on-demand section-padding">
      <div class="row">
        <H2FeaturedHeader featuredHeader="Sharecare Windows on demand"/>
        <div class="on-demand-images">
          <div class="on-demand-images-container">
            <div class="on-demand-images-inner-container relaxing">
              <FeaturedSubHeader featuredContent="Relaxing HD videos available anytime, anyplace, on any device." />
              <div class="main-img">
                <picture>
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/media-devices.jp2`" type="image/jp2">
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/media-devices.webp`" type="image/webp">
                  <img class="lazyload" alt="Various media devices" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/media-devices.png`" />
                </picture>
              </div>
            </div>
            <div class="on-demand-images-inner-container access">
              <FeaturedSubHeader featuredContent="Access Sharecare Windows on any of these platforms:" />
              <div class="sub-imgs">
                <div class="sub-img">
                  <a rel="noopener" target="_new" href="http://amazon.com/v/">
                    <picture>
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-amazon.jp2`" type="image/jp2">
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-amazon.webp`" type="image/webp">
                      <img class="lazyload" alt="Amazon logo" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-amazon.png`" />
                    </picture>
                  </a>
                </div>
                 <div class="sub-img">
                  <a rel="noopener" target="_new" href="https://apps.apple.com/us/app/sharecare-windows/id1371630055">
                    <picture>
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-iphone.jp2`" type="image/jp2">
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-iphone.webp`" type="image/webp">
                      <img class="lazyload" alt="iPhone logo" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-iphone.png`" />
                    </picture>
                  </a>
                </div>
                 <div class="sub-img">
                  <a rel="noopener" target="_new" href="https://windows.sharecare.com/help/using-the-apple-tv-app/apple-tv-apps">
                    <picture>
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-apple-tv.jp2`" type="image/jp2">
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-apple-tv.webp`" type="image/webp">
                      <img class="lazyload" alt="Apple TV logo" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-apple-tv.png`" />
                    </picture>
                  </a>
                </div>
                <div class="sub-img">
                  <a rel="noopener" target="_new" href="https://play.google.com/store/apps/details?id=com.sharecare.realgreen&hl=en_US">
                    <picture>
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-android.jp2`" type="image/jp2">
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-android.webp`" type="image/webp">
                      <img class="lazyload" alt="Android logo" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-android.png`" />
                    </picture>
                  </a>
                </div>
               
               
                <div class="sub-img">
                  <a rel="noopener" target="_new" href="https://play.google.com/store/apps/details?id=com.windowchannel">
                    <picture>
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-android-tv.jp2`" type="image/jp2">
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-android-tv.webp`" type="image/webp">
                      <img class="lazyload" alt="Android TV logo" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-android-tv.png`" />
                    </picture>
                  </a>
                </div>
                
                <div class="sub-img">
                  <a rel="noopener" target="_new" href="https://www.amazon.com/gp/product/B07CSK7PPW/">
                    <picture>
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-fire-tv.jp2`" type="image/jp2">
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-fire-tv.webp`" type="image/webp">
                      <img class="lazyload" alt="Fire TV logo" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-fire-tv.png`" />
                    </picture>
                  </a>
                </div>
                <div class="sub-img">
                  <a rel="noopener" target="_new" href="https://channelstore.roku.com/details/238845/window-channel-on-demand">
                    <picture>
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-roku.jp2`" type="image/jp2">
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-roku.webp`" type="image/webp">
                      <img class="lazyload" alt="Roku logo" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-roku.png`" />
                    </picture>
                  </a>
                </div>
                <div class="sub-img">
                  <a rel="noopener" target="_new" href="https://www.oculus.com/experiences/go/2500224536702304/">
                    <picture>
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-oculus.jp2`" type="image/jp2">
                      <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-oculus.webp`" type="image/webp">
                      <img class="lazyload" alt="Oculus logo" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/access-sharecare-windows-oculus.png`" />
                    </picture>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="awards-section section-padding">
      <div class="row">
        <H2FeaturedHeader featuredHeader="Awards"/>
        <FeaturedSubHeader featuredContent="Sharecare Windows videos have screened at over 170 film festivals around the world and garnered 42 awards from Best Eco Film to Best Cinematography to Best Short. Facing some of the best filmmakers in the world, we are humbled and honored to have our videos selected by the festivals below" />
        
        <div class="awards-video-callouts-container">
          
          <div class="callout">
            <div class="callout-text">Water</div>
            <div class="callout-video">
              <picture>
                <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/awards-water-video.jp2`" type="image/jp2">
                <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/awards-water-video.webp`" type="image/webp">
                <img class="lazyload" alt="Glaciers on the water" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/awards-water-video.png`" />
              </picture>
              <div class="callout-play-button" data-video-id="6055217018001">
                <picture>
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/play-button.jp2`" type="image/jp2">
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/play-button.webp`" type="image/webp">
                  <img class="lazyload" alt="Play video button" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/play-button.png`" />
                </picture>
              </div>
            </div>
          </div>

          <div class="callout">
            <div class="callout-text">Shinrin-yoku</div>
            <div class="callout-video">
              <picture>
                <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/awards-shinrin-yoku-video.jp2`" type="image/jp2">
                <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/awards-shinrin-yoku-video.webp`" type="image/webp">
                <img class="lazyload" alt="Road through the woods" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/awards-shinrin-yoku-video.png`" />
              </picture>
              <div class="callout-play-button" data-video-id="6055213618001">
                <picture>
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/play-button.jp2`" type="image/jp2">
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/play-button.webp`" type="image/webp">
                  <img class="lazyload" alt="Play video button" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/play-button.png`" />
                </picture>
              </div>
            </div>
          </div>

        </div>

        <div class="awards-ribbon-callouts-container">
          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="awards-snowdance.png"
          calloutImgNameWebp="awards-snowdance.webp"
          calloutImgNameJP2="awards-snowdance.jp2"
          alternativeText="Finalist snowdance film awards 2018" 
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="awards-webdance.png"
          calloutImgNameWebp="awards-webdance.webp"
          calloutImgNameJP2="awards-webdance.jp2"
          alternativeText="Winner webdance film festival 2018" 
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="awards-west-wing.png"
          calloutImgNameWebp="awards-west-wing.webp"
          calloutImgNameJP2="awards-west-wing.jp2" 
          alternativeText="Best short film west wing film competition 2018"
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="awards-oniros.png"
          calloutImgNameWebp="awards-oniros.webp"
          calloutImgNameJP2="awards-oniros.jp2"
          alternativeText="Finalist oniros film awards 2018" 
          />

        </div>

        <div class="featured-content-bottom">
          Since 2005, Sharecare Window’s HD programming and specialty video production has transported viewers to a wide realm of exotic locales around the world.<br /><br />Always seeking a new and unique perspective, Sharecare Window’s team of filmmakers carefully scout locations to capture breathtaking images that simulate the experience of actually being in that very place—at that very time. Videos filmed in HD and 4K are accompanied by naturally occurring background sounds in nature resulting in spectacular images that engage, relax and entertain.
        </div>

      </div>
    </section>


    <section class="healthcare lazyload" :data-bg="`${staticAssetPath}/img/sharecare-windows/healthcare-bg.jpg`">
      <div class="row">
        <div class="featured-header">Healthcare</div>
        <FeaturedSubHeader featuredContent="Healing videos for rest and relaxation" />
      </div>
    </section>


    <section class="original-wellness section-padding">
      <div class="row">
        <H2FeaturedHeader featuredHeader="Original wellness relaxation video for better outcomes" />
        <FeaturedSubHeader featuredContent="With change and uncertainty defining the healthcare landscape, one core operating principle is more essential than ever—successful hospitals must demonstrate a culture and a commitment to provide a comforting environment and optimal experience for patients and families. Hospitals can be noisy, disruptive, and stressful with tests, clinical conversations, and up to 20 staff visits a day per room. Patients are often lonely, scared, and confused.<br /><br />That’s why over 500 hospitals choose Sharecare Windows as part of an integrated content strategy to enhance the patient experience, improve outcomes, and accelerate efforts to reduce noise and create a restful and peaceful environment. With five carefully selected categories of relaxation, inspiration and sleep focused videos, Sharecare Windows partner hospitals have seen proven results and enhanced reimbursements." />
      </div>
    </section>


    <section class="testimonials section-padding">
      <div class="row">
        <H2FeaturedHeader featuredHeader="Testimonials" />
      </div>
        <div class="testimonial-callout-container owl-carousel">
          
          <div class="callout">
            <div class="upper">
              <div class="callout-img">
                <picture>
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/chuck-podesta.jp2`" type="image/jp2">
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/chuck-podesta.webp`" type="image/webp">
                  <img class="lazyload" alt="Chuck Podesta" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/chuck-podesta.png`" />
                </picture>
              </div>
              <div class="callout-content">&quot;The Window Channel’s HD content displays beautifully on our high definition televisions throughout all 563 beds in our hospital. Our patients and staff find it provides a key element to our goal in creating a comfortable, soothing  environment ideal for healing.&quot; 
              </div>
            </div>
            
            <div class="callout-person-info">
              <div class="name">Chuck Podesta</div>
              <div class="position">SVP and Chief Information Officer, Fletcher-Allen Health Care</div>
            </div>
          </div>

          <div class="callout">
            <div class="upper">
              <div class="callout-img">
                <picture>
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/kevin-meek.jp2`" type="image/jp2">
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/kevin-meek.webp`" type="image/webp">
                  <img class="lazyload" alt="Kevin Meek" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/kevin-meek.png`" />
                </picture>
              </div>
              <div class="callout-content">&quot;The use of relaxation videos helps patients relax before and after therapy sessions, aids sleeping, and helps reduce hospital noise in the patient room. Although there are several styles and brands of relaxation content available, none meet the quality, selection, and cost that The Window Channel offers its clients. The high-definition scenic videos are enjoyed by both patients and families alike.&quot; 
              </div>
            </div>
            
            <div class="callout-person-info">
              <div class="name">Kevin Meek</div>
              <div class="position">VP Patient Care Services/Clinical Operations, Adeptus Health</div>
            </div>
          </div>

          <div class="callout">
            <div class="upper">
              <div class="callout-img">
                <picture>
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/mark-hazelwood.jp2`" type="image/jp2">
                  <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/mark-hazelwood.webp`" type="image/webp">
                  <img class="lazyload" alt="Mark Hazelwood" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/mark-hazelwood.png`" />
                </picture>
              </div>
              <div class="callout-content">&quot;An important part of our interactive television offerings, The Window Channel contributes significantly to the creation of positive, memorable experiences for our patients and their families.<br/>The Window Channel’s unique and creative programming, filled with beautiful and engaging sights and sounds, contributes to a relaxing and positive environment. The positive feedback that we have received reinforces our decision to feature The Window Channel.&quot; 
              </div>
            </div>
            
            <div class="callout-person-info">
              <div class="name">Mark L. Hazelwood</div>
              <div class="position">President, Mark Hazelwood &amp; Associates</div>
            </div>
          </div>

      </div>
    </section>


    <section class="partners section-padding">
      <div class="row">
        <H2FeaturedHeader featuredHeader="Partners" />
        <div class="partners-callout-container">
          
          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="nabed-logo.png"
          calloutImgNameWebp="nabed-logo.webp"
          calloutImgNameJP2="nabed-logo.jp2"
          alternativeText="Nabed" 
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="amazon.png"
          calloutImgNameWebp="amazon.webp"
          calloutImgNameJP2="amazon.jp2"
          alternativeText="Amazon" 
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="swank.png" 
          calloutImgNameWebp="swank.webp"
          calloutImgNameJP2="swank.jp2"
          alternativeText="Swank"
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="aceso-e.png"
          calloutImgNameWebp="aceso-e.webp"
          calloutImgNameJP2="aceso-e.jp2"
          alternativeText="Aceso" 
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="telehealth-logo.png" 
          calloutImgNameWebp="telehealth-logo.webp" 
          calloutImgNameJP2="telehealth-logo.jp2" 
          alternativeText="Telehealth services"
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="cancer-treatment-center-logo.png"
          calloutImgNameWebp="cancer-treatment-center-logo.webp"
          calloutImgNameJP2="cancer-treatment-center-logo.jp2"
          alternativeText="Cancer treatment centers of america" 
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="pcare.png"
          calloutImgNameWebp="pcare.webp"
          calloutImgNameJP2="pcare.jp2"
          alternativeText="PCARE" 
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="coro-health.png"
          calloutImgNameWebp="coro-health.webp"
          calloutImgNameJP2="coro-health.jp2" 
          alternativeText="Coro health"
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="spectrio.png"
          calloutImgNameWebp="spectrio.webp"
          calloutImgNameJP2="spectrio.jp2"
          alternativeText="Spectrio" 
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="getwell-network.png"
          calloutImgNameWebp="getwell-network.webp"
          calloutImgNameJP2="getwell-network.jp2"
          alternativeText="Getwell network" 
          />

          <StandardCallout 
          assetFolder="sharecare-windows" 
          calloutImgName="criterion.png"
          calloutImgNameWebp="criterion.webp"
          calloutImgNameJP2="criterion.jp2"
          alternativeText="Criterion" 
          />

        </div>

      </div>
    </section>


    <section class="hospitality">
      <div class="bg-img lazyload" :data-bg="`${staticAssetPath}/img/sharecare-windows/hospitality-bg-mobile.jpg`">
        <div class="bg-img-icon-overlay-container">
          <div class="bg-img-icon-overlay">
            <picture>
              <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/forbes-travel-guide.jp2`" type="image/jp2">
              <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/forbes-travel-guide.webp`" type="image/webp">
              <img class="lazyload" alt="Forbes travel guide" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/forbes-travel-guide.png`" />
            </picture>
          </div>
        </div>
        <div class="row">
          <div class="featured-header">Hospitality</div>
          <FeaturedSubHeader featuredContent="Relaxation and mindfulness videos for your guests" />
        </div>
      </div>

      <div class="row section-padding">
        <FeaturedSubHeader featuredContent="Creating transformational digital imagery since 2005, Sharecare Windows is the leading producer of original HD video, VR and in-room entertainment for some of the world’s premier tourism destinations and properties. Our original programming engages viewers, attracting high-end guests to luxury brands and destinations and delivering the ultimate amenity—inspiration.<br /><br />For 30 years the world’s leading destinations and brands, including St. Regis Hotels, W Hotels, Four Seasons Hotels, Taj Hotels and Mandarin Oriental Hotels have relied on Sharecare Windows’ high-quality HD video and VR to enhance guest satisfaction and create repeat guests.<br /><br />With a library consisting of 175 titles and 235 hours of original programming we have a solution for your Spa, In-Room, Food and Beverage outlets, Public Spaces and your younger guests. We also produce custom tours of your property to attract new visitors and meeting planners.<ul><li>Spa programming includes extensive yoga, guided meditation, yoga music, breathing techniques, and relaxing ambient backgrounds.</li><li>In-Room programming includes ambient backgrounds, soothing nature relaxation and our comprehensive sleep programming guaranteeing 	your guest will get their best nights’ sleep between your sheets.</li><li>Food and Beverage programs include our immensely popular “Cocktail Hour” featuring smooth Jazz and upbeat popular music accompanied 	by spectacular video from around the world.</li><li>Public space and Social Events programming include a wide variety of nature video, and background ambience to choose from.</li><li>For younger guests we offer Kids World, relaxation video created especially for guests ages 2-12 with a variety of engaging and interesting visuals-perfect for your kids club or in-room.</li></ul>" />

        <div class="featured-callout callout-play-button" data-video-id="6055866738001">
          <picture>
            <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/hospitality-demo.jp2`" type="image/jp2">
            <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/hospitality-demo.webp`" type="image/webp">
            <img class="lazyload" alt="In-room relaxation" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/hospitality-demo.jpg`" />
          </picture>
        </div>

      </div>
    </section>


    <section class="windows-360-vr-video section-padding">
      <div class="row">
        <H2FeaturedHeader featuredHeader="Sharecare Windows 360 and VR Video" />
        <FeaturedSubHeader featuredContent="Sharecare Windows is also one of the leading innovators of high-quality, original VR and 360 video technology, having created totally immersive VR content used in both the healthcare and hospitality industries." />
        <div class="featured-callout callout-play-button" data-video-id="6055870705001">
           <picture>
            <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/windows-360-vr-video.jp2`" type="image/jp2">
            <source :data-srcset="`${staticAssetPath}/img/sharecare-windows/windows-360-vr-video.webp`" type="image/webp">
            <img class="lazyload" alt="Virtual reality" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/windows-360-vr-video.png`" />
          </picture>
        </div>
      </div>
    </section>


    <section class="contact-us section-padding">
      <div class="row">
        <H2FeaturedHeader featuredHeader="Start your view to a happy, healthier life." />
        <FeaturedSubHeader featuredContent="Contact us to discuss partnering with Sharecare Windows to help your audience transform their mind, body and spirit." />
        <div class="contact-form">
          <iframe class="lazyload" title="Windows contact form" :data-src="`${staticPageManagerPath}/form/windows-contact-form`" width="100%" scrollling="no" frameborder="0" allowtransparency="true"></iframe>
        </div>
      </div>
      
    </section>
    
    <div class="video-modal">
      <div class="video-modal__close">
        <img class="lazyload" alt="Close window" border="0" :data-src="`${staticAssetPath}/img/sharecare-windows/modal-close.svg`" />
        </div>
    </div>

    

  </div>
  
</template>

<script>
//import '../../assets/styles/main.scss';
import '../../assets/styles/page-templates/sharecare-windows.scss';
import "../../assets/vendor/iframeResizer.min";
import SharecareWindows from "../../assets/js/sharecare-windows";
import H2FeaturedHeader from "../../components/H2FeaturedHeader.vue";
import FeaturedSubHeader from "../../components/FeaturedSubHeader.vue";
//import StandardListItemCallout from "../../components/StandardListItemCallout.vue";
import StandardCallout from "../../components/StandardCallout.vue";
import StandardListItemCalloutWithLinkText from "../../components/StandardListItemCalloutWithLinkText.vue";
import 'lazysizes';

setTimeout(function() {
new SharecareWindows(process.env.VUE_APP_BASE_URL + process.env.VUE_APP_ASSETS_URL);
},100)


   export default {
     components: {
      H2FeaturedHeader,
      FeaturedSubHeader,
      //StandardListItemCallout,
      StandardCallout,
      StandardListItemCalloutWithLinkText
    },
      data () {
        return {
          staticAssetPath: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_ASSETS_URL,
          staticPageManagerPath: process.env.VUE_APP_STATIC_PAGE_MANAGER_URL
        }
      }
    }
</script>
